import { useController, useFormContext } from 'react-hook-form';

import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { Description, FieldGroup, Label } from '@gitbook/spine-react';

import type { CustomizationLinkStyle } from './types';

const linkStyleOptions: PickerItemData<CustomizationLinkStyle>[] = [
    {
        value: 'link',
        label: 'Link',
    },
    {
        value: 'button-primary',
        label: 'Primary button',
    },
    {
        value: 'button-secondary',
        label: 'Secondary button',
    },
];

export function LinkStyleField(props: { name: string }) {
    const { control } = useFormContext();
    const { field } = useController({
        name: props.name,
        control,
        rules: {
            required: 'Required',
        },
    });

    return (
        <FieldGroup>
            <Label>Style</Label>
            <Description>Choose how the link should appear.</Description>
            <Picker
                value={field.value}
                items={linkStyleOptions}
                onValueChange={field.onChange}
                size="medium"
            />
        </FieldGroup>
    );
}
